import { useParams } from "react-router";
import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";

export default function SingleSubjectIPAdministration() {
  const { subjectId } = useParams();
  return (
    <MetadataDashboardTemplate
      type="dosage_ip_administration"
      subjectId={subjectId}
      constants={{
        wikiLink: "/wiki/guides/exploration-singlesubject-ip-administration",
        idLink: undefined,
      }}
    />
  );
}
